// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"156":"6026a540","806":"14eb4d56"}[chunkId] + ".css";
};